import { render, staticRenderFns } from "./ParticaSnackbar.vue?vue&type=template&id=1c813e15&"
import script from "./ParticaSnackbar.vue?vue&type=script&lang=ts&"
export * from "./ParticaSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports